module.exports = __webpack_public_path__ + "0421bf42380b4f3e2816bb6eb2b9110b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/monsters.png
// module id = 3177
// module chunks = 0